"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("@material-ui/core/styles");

var styles = function styles(theme) {
  return {
    root: {
      padding: [[0, theme.spacing(3), theme.spacing(3), theme.spacing(3)]]
    },
    facetContainer: {
      padding: [[theme.spacing(3), 0, 0, 0]]
    },
    genericInput: {
      fontSize: theme.typography.caption.fontSize,
      flexGrow: 1,
      flexShrink: 1
    },
    buttonRow: {
      padding: '12px 16px',
      display: 'flex',
      flexDirection: 'row-reverse',
      flexWrap: 'nowrap',
      alignItems: 'center',
      justifyContent: 'flex-start'
    }
  };
};

var _default = (0, _styles.withStyles)(styles);

exports["default"] = _default;